export default "__VITE_ASSET__BjPE_lB2__"